import { createRouter, createWebHistory } from 'vue-router';

// Page List

import escoLogin from '../views/esco-login.vue';
import escoTelaPrincipal from '../views/esco-tela-principal.vue';
import escoConversaEmAndamento from '../views/esco-conversa-em-andamento.vue';
import escoChatDeQuestoes from '../views/esco-chat-de-questoes.vue';
// import escoConversaDefault from '../views/esco-conversa-default.vue';
import escoConversaEmAndamentoOrder from '../views/esco-conversa-em-andamento-order.vue';
import escoAtivarConta from '../views/esco-ativar-conta.vue';
import escoEsqueciSenha from '../views/esco-esqueci-senha.vue';
import escoConfiguracoes from '../views/esco-configuracoes.vue';
import escoConfiguracaoEmpresa from '../views/esco-configuracao-empresa.vue';
import escoConfiguracaoEquipe from '../views/esco-configuracao-equipe.vue';
import escoAgentesLista from '../views/esco-agentes-lista.vue';
import escoModulosMarketplace from '../views/esco-modulos-marketplace.vue';
import escoMaisEmBreve from '../views/esco-mais-em-breve.vue';


const routes = [

    // Page - Login

    {
        path: '/',
        name: 'Login',
        component: escoLogin
    },

    // Page - Conversa Default

    // {
    //     path: '/conversa-default',
    //     name: 'Conversa Default',
    //     component: escoConversaDefault
    // },

    // Page - Conversa Em Andamento

    {
        path: '/conversa-em-andamento/:slug',
        name: 'Conversa Em Andamento',
        component: escoConversaEmAndamentoOrder
    },
    // Page - Tela Principal

    {
        path: '/tela-principal',
        name: 'Tela Principal',
        component: escoTelaPrincipal
    },
    {
        path: '/mais',
        name: 'Mais Em Breve',
        component: escoMaisEmBreve
    },
    {
        path: '/agentes',
        name: 'Agentes Lista',
        component: escoAgentesLista
    },
    {
        path: '/modulos',
        name: 'Modulos Marketplace',
        component: escoModulosMarketplace
    },
    {
        path: '/configuracoes',
        name: 'Configuracoes',
        component: escoConfiguracoes
    },
    {
        path: '/configuracao-empresa',
        name: 'Configuracao Empresa',
        component: escoConfiguracaoEmpresa
    },
    {
        path: '/configuracao-equipe',
        name: 'Configuracao Equipe',
        component: escoConfiguracaoEquipe
    },

    // Page - Conversa Em Andamento

    {
        path: '/chat',
        name: 'Chat',
        component: escoConversaEmAndamento
    },

    // Page - Chat De Questoes

    {
        path: '/chat-de-questoes',
        name: 'Chat De Questoes',
        component: escoChatDeQuestoes
    },
    {
        path: '/ativar-conta/:slug',
        name: 'Ativar Conta',
        component: escoAtivarConta
    },
    {
        path: '/esqueci-senha',
        name: 'Esqueci Senha',
        component: escoEsqueciSenha
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

export default router;
